import { $, e } from "venuescanner-js/tools/elemental";
// eslint-disable-next-line no-unused-vars
import { node, domRenderer } from "venuescanner-js/tools/jsx";
import { lazyload } from "venuescanner-js/vanilla/widgets/lazyload";
import "./popup";
/*
 options = {
   onclose:function(){}, - the on closing callback
   closable:true, - allows the dialog to be closed
   loading:true, - shows the spinner
   notBackground:true - if true prevents closing on the background
  }blockout on closable
 */
const styles = ["chargebee"];
const dialog = function (html, options) {
  this.dialog = null;
  this.content = null;
  this.closable = function (active) {
    if (this.dialog !== null) {
      if (active === true) {
        this.dialog.addClass("closable");
      } else {
        this.dialog.removeClass("closable");
      }
    }
  };
  this.optionClasses = function (options) {
    if (options.className !== undefined)
      this.content.addClass(options.className);
    if (options.loading === true) {
      this.content.addClass("loading");
    } else {
      this.content.removeClass("loading");
    }
    if (options.success === true) {
      this.content.addClass("success");
    } else {
      this.content.removeClass("success");
    }
    if (options.success === false) {
      this.content.addClass("failure");
    } else {
      this.content.removeClass("failure");
    }
    if (options.notice === true) {
      this.content.addClass("notice");
    } else {
      this.content.removeClass("notice");
    }
  };
  this.set = function (options) {
    this.optionClasses(options);
    if (options.closable !== undefined) this.closable(options.closable);
  };
  this.show = function (html, options) {
    try {
      if (html.render instanceof Function) {
        html = html.render(domRenderer);
      }
      if (typeof options == "undefined") options = {};
      if (this.content === null) {
        this.content = e("div").addClass("popup_content");
      }

      this.optionClasses(options);
      if (typeof html != "undefined" && html !== null) {
        if (typeof html === "string") {
          this.content.html(html);
        } else if (html.get) {
          this.content.empty();
          let elements = [...html.get()];
          while (elements.length > 0) {
            this.content.append(elements.shift());
          }
        } else if (html instanceof HTMLElement) {
          this.content.empty().append(html);
        }
      }
      if (options.container) {
        let target = $(options.container);
        target.append(this.content);
      } else if (this.dialog === null) {
        let _this = this;

        const popupWindow = e("div")
          .addClass(`popup_window${options.fullscreen ? " fullscreen" : ""}`)
          .append(this.content)
          .append(e("button").click(() => this.close(true, options)));

        if (options.noPadding === true) {
          popupWindow.addClass("noPadding");
        }

        this.dialog = e("div")
          .addClass("blockout")
          .append(popupWindow)
          .click(function (e) {
            if (
              $(this).hasClass("closable") &&
              options.notBackground === false
            ) {
              if (e.target === this) _this.close(true, options);
            }
          });

        if (options.overIntercom === true) {
          this.dialog.addClass("overIntercom");
        } else {
          this.dialog.removeClass("overIntercom");
        }
        $(document.body).append(this.dialog);

        setTimeout(() => {
          if (this.dialog) this.dialog.addClass("on");
          if (options.onReady !== undefined) options.onReady.apply(this, []);
        }, 50);
      }
      const dialogElement = this.dialog.get(0);
      // console.log(this.dialog.get(0).className.split(' '))
      if (dialogElement) {
        const classes = dialogElement.className
          .split(" ")
          .filter((className) => !className.match(/^style_/));

        if (options.style && styles.includes(options.style))
          classes.push(`style_${options.style}`);
        if (dialogElement) dialogElement.className = classes.join(" ");
      }

      if (options.closable !== undefined) this.closable(options.closable);
      setTimeout(() => {
        lazyload.init();
      }, 0);
    } catch (e) {
      console.error(e);
    }
  };
  this.close = function (fromClick, options) {
    if (this.dialog !== null) {
      this.dialog.remove();
      this.dialog = null;
      this.content = null;
    }
    if (!!options && !!fromClick && typeof options.onclose == "function")
      options.onclose();
    popup.removeFrom(this);
  };
  this.show(html, options);
};
const popup = {
  dialogs: [],
  closable: function (active) {
    this.clearUnused();
    let box = this.getLastest();
    if (box !== null) {
      box.closable(active);
    }
  },
  clearUnused: function () {
    for (let d = this.dialogs.length - 1; d >= 0; d--) {
      if (
        this.dialogs[d].dialog === null ||
        this.dialogs[d].dialog.parentNode === null
      )
        this.dialogs.splice(d, 1);
    }
  },
  getLastest: function () {
    if (this.dialogs.length == 0) return null;
    return this.dialogs[this.dialogs.length - 1];
  },
  new: function (html, options) {
    const box = new dialog(html, options);
    this.dialogs.push(box);
    return box;
  },
  set: function (opts) {
    const d = this.getLastest();
    if (d) d.set(opts);
  },
  show: function (html, options) {
    this.clearUnused();
    let box = this.getLastest();
    // console.log(box)
    if (box === null) {
      box = new dialog(html, options);
      this.dialogs.push(box);
    } else {
      box.show(html, options);
    }
    return box;
  },
  close: function () {
    this.clearUnused();
    let box = this.getLastest();
    if (box !== null) {
      box.close();
    }
  },
  closeAll: function () {
    for (let d = this.dialogs.length - 1; d >= 0; d--) {
      this.dialogs[d].close();
    }
  },
  removeFrom: function (dialog) {
    if (this.dialogs.indexOf(dialog) >= 0)
      this.dialogs.splice(this.dialogs.indexOf(dialog), 1);
  },
};
export { popup, dialog };
if (typeof window !== "undefined") window.popup = popup; // required for Calendar
